module.exports = __webpack_public_path__ + "img/Primordial-4-mobile.1f8c0b17.png";